import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ScrollToTop } from './components/layout/scrollTop/scrollToTop'

import Main from './containers/main'
import MakeClaimMailReferral from './containers/makeClaimMailReferral'
import SignDocuments from './containers/signDocuments'
import PrivacyPolicy from './containers/privacyPolicy'
import Terms from './containers/terms'
import TestRunner from './containers/testRunner'

export default function AppRouter() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Main />}>
                    <Route path="/" element={<MakeClaimMailReferral />} />
                    <Route path="/sign/:token" element={<SignDocuments />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-conditions" element={<Terms />} />
                </Route>
                {/* DEV-ONLY permutation test runner. Isolated outside <Main> so it
                    shares none of the real form's layout, providers or claim state. */}
                <Route path="/test" element={<TestRunner />} />
            </Routes>
        </Router>
    )
}
